import React from "react";
import ParallaxSection from "./parallex1";
import bgImage from "../../assets/images/Testimonial/Tesrimonial.jpg"; // check correct path

const Instrui = () => {
  return (
    <div>
      <ParallaxSection title="Industries We Serve" backgroundImage1={bgImage}>
      </ParallaxSection>
    </div>
  );
};

export default Instrui;
